import React from 'react';
import DrawToolSelection from './toolSelection/DrawToolSelection';
import DrawList from './drawList/DrawList';
import DrawInfoBox from './DrawInfoBox';

const Draw = () => (
  <>
    <DrawInfoBox />
    <div className="tooldialog__wrapper">
      <DrawToolSelection />
      <DrawList />
    </div>
  </>
);

export default Draw;
